import './myaToken';
import './translation';
import './dashboardResolver';
import './rootResolver';



// WEBPACK FOOTER //
// ./scripts/common/resolvers/index.js